/**
 * Rich Text New Window
 * v1.0.0
 */
const richtextNewWindow = () => {
    document.querySelectorAll('.richtext a').forEach(el => {
        const href = el.getAttribute('href');
        const origin = window.location.origin;
 
        if (!href.startsWith(origin) || href.startsWith(`${origin}/assets/`)) {
            el.setAttribute('target', '_blank');
        }
    });
}

document.addEventListener('DOMContentLoaded', richtextNewWindow);

export default richtextNewWindow;
